/* eslint-env es5 */

// This function MUST be ES5–compatible — will be stringified

/* istanbul ignore next */
export default function ScriptHandleBannerVisibility(id) {
  try {
    var element = document.getElementById(id)

    if (localStorage.getItem(id) && element) {
      element.remove()
    }
  } catch (_) {
    /* ignore error */
  }
}
